export default "__VITE_ASSET__d7aca93d__"